import { render } from "./ItemDescription.vue?vue&type=template&id=701f3a43&ts=true"
import script from "./ItemDescription.vue?vue&type=script&setup=true&lang=ts"
export * from "./ItemDescription.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/item/ItemDescription.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "701f3a43"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('701f3a43', __exports__)) {
    api.reload('701f3a43', __exports__)
  }
  
  module.hot.accept("./ItemDescription.vue?vue&type=template&id=701f3a43&ts=true", () => {
    api.rerender('701f3a43', render)
  })

}


export default __exports__